<template>
  <div class="c-push-entrepreneur">
    <entrepreneur-vertical-name
      v-if="page.data.first_name && page.data.last_name"
      :first-name="page.data.first_name[0].text"
      :last-name="page.data.last_name[0].text"
    />
    <entrepreneur-intro :data="page.data" :uid="page.uid" />
  </div>
</template>

<script>
import EntrepreneurIntro from "components/EntrepreneurIntro/EntrepreneurIntro";
import EntrepreneurVerticalName from "components/EntrepreneurVerticalName/EntrepreneurVerticalName";
export default {
  components: {
    EntrepreneurIntro,
    EntrepreneurVerticalName
  },
  props: {
    page: {
      type: Object,
      required: true
    },
    uid: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
.c-push-entrepreneur {
  display: flex;
  flex-direction: column;
  flex: 1;
  @media #{$breakpoint-horizontal} {
    flex-direction: row;
    height: 100%;
  }
}
</style>
